/*
[GNU Affero General Public License (AGPL)](https://www.gnu.org/licenses/agpl-3.0.html)

VeloceSupabase - A library for working with supabase made in Angular v17+ made with care by Colibryx Srl in Italy.
Copyright (C) 2025 Colibryx S.r.l.

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as published by
the Free Software Foundation, either version 3 of the License, or
(at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program. If not, see <https://www.gnu.org/licenses/>.
*/

import { Injectable, inject } from "@angular/core";
import { BehaviorSubject, Subject } from "rxjs";

interface ActionLog {
	description: string;
	data?: unknown;
}

@Injectable({
	providedIn: "root",
})
export class ActionLoggerService {
	private readonly maxLogs = 150;
	private readonly _logs: ActionLog[] = [];

	private readonly logs$ = new Subject<ActionLog>();

	constructor() {
		this.logs$.subscribe((log) => {
			this._logs.push(log);

			if (this._logs.length > this.maxLogs) {
				this._logs.shift();
			}
		});
	}

	public get logs(): ActionLog[] {
		return this._logs;
	}

	public registerAction(description: string, data?: unknown): void {
		this.logs$.next({
			description,
			data,
		});
	}

	public deleteActionLog(index: number): void {
		this._logs.splice(index, 1);
	}
}
